import React from 'react';

import { Grid, Typography } from '@mui/material';

export const TutorContractPlanHeader: React.FC = () => {
  return (
    <Grid container spacing={3} alignItems="center" px={1}>
      <Grid item sm={12} lg={6}>
        <Typography fontWeight={400} fontSize={24} color="#000000">
          ASSINAR PLANO
        </Typography>
      </Grid>
    </Grid>
  );
};
